(() => {
  const root = document.querySelector('[data-ms-cute-root]');
  if (!root) return;

  const button = root.querySelector('[data-ms-cute-trigger]');
  const layer = root.querySelector('[data-ms-cute-layer]');
  const status = root.querySelector('[data-ms-cute-status]');
  const productImages = [...root.querySelectorAll('[data-ms-cute-image]')]
    .map((item) => item.dataset.msCuteImage)
    .filter(Boolean);
  const emojis = ['🥟', '💗', '✨', '🌸', '☁️'];
  let active = false;

  const randomBetween = (minimum, maximum) => Math.random() * (maximum - minimum) + minimum;

  const createDrop = (index, total) => {
    const drop = document.createElement('span');
    const useProduct = productImages.length && index % 4 !== 3;
    const laneWidth = 100 / total;
    const left = Math.min(96, Math.max(1, (index * laneWidth) + randomBetween(0, laneWidth * .75)));

    drop.className = `ms-cute-drop${useProduct ? '' : ' ms-cute-drop--emoji'}`;
    drop.style.setProperty('--ms-cute-left', `${left}%`);
    drop.style.setProperty('--ms-cute-delay', `${randomBetween(0, 520).toFixed(0)}ms`);
    drop.style.setProperty('--ms-cute-duration', `${randomBetween(1800, 2550).toFixed(0)}ms`);
    const drift = randomBetween(-55, 55);
    drop.style.setProperty('--ms-cute-drift', `${drift.toFixed(0)}px`);
    drop.style.setProperty('--ms-cute-return-drift', `${(drift * -.5).toFixed(0)}px`);
    drop.style.setProperty('--ms-cute-static-top', `${randomBetween(8, 84).toFixed(0)}vh`);
    drop.style.setProperty('--ms-cute-rotation', `${randomBetween(-35, 35).toFixed(0)}deg`);
    drop.style.setProperty('--ms-cute-size', `${randomBetween(window.innerWidth < 750 ? 43 : 54, window.innerWidth < 750 ? 60 : 78).toFixed(0)}px`);
    drop.style.setProperty('--ms-cute-sparkle', index % 3 === 0 ? "'✨'" : "''");

    if (useProduct) {
      const image = document.createElement('img');
      image.src = productImages[index % productImages.length];
      image.alt = '';
      image.loading = 'eager';
      drop.append(image);
    } else {
      drop.textContent = emojis[index % emojis.length];
    }
    return drop;
  };

  button?.addEventListener('click', () => {
    if (active) return;
    active = true;
    button.setAttribute('aria-pressed', 'true');
    status.textContent = 'Cute mode activated. Squishies are raining!';

    const total = window.innerWidth < 750 ? 18 : 28;
    const fragment = document.createDocumentFragment();
    for (let index = 0; index < total; index += 1) fragment.append(createDrop(index, total));
    layer.replaceChildren(fragment);

    window.setTimeout(() => {
      layer.replaceChildren();
      button.setAttribute('aria-pressed', 'false');
      status.textContent = 'Cute mode finished.';
      active = false;
    }, 3200);
  });
})();
